import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFAmazon from '@/components/UI/svg/river2/Icon/EFAmazon';
import { EFRakuten, EFShopify, EFarrow, EFJD } from '@/components/UI/svg/river2';
import { BuyBtnType, buyLinkMap3 } from '@/components/productRiver/river2/Details/components/D';
import { getImageSpec } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/river2/h5/');
const { EFPic: EFPic2 } = createEFPic('');
const IconAct = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="218" height="42" viewBox="0 0 218 42" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H218L213.169 25.6952C211.392 35.1502 203.134 42 193.514 42H23.0492C13.0066 42 4.52129 34.5526 3.2183 24.5949L0 0Z"
            fill="url(#paint0_linear_1_5914)"
        />
        <defs>
            <linearGradient id="paint0_linear_1_5914" x1="-108.588" y1="-4.60126" x2="-107.86" y2="56.7541" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FD9DF3" />
                <stop offset="1" stopColor="#6134FD" />
            </linearGradient>
        </defs>
    </svg>
);

export default function D({ IS_ZA_SALE, IS_ZA_END }: any) {
    const { useEffect, useState, useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['cn', 'jp', 'uk', 'de', 'fr', 'es', 'it', 'eu', 'za', 'au']);
    const [winW, setWinW] = useState(375);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setWinW(window?.innerWidth);
        }
    }, []);

    const [swiper, setSwiper] = useState({ activeIndex: 0 });
    const [active, setActive] = useState(0);

    const onSlideChange = (swiper: any) => {
        setActive(swiper?.realIndex || swiper.activeIndex % 3);
    };
    const onPrev = () => {
        const preIndex = swiper?.realIndex - 1;
        swiper?.slideToLoop(preIndex < 0 ? 2 : preIndex);
        setActive(swiper?.realIndex);
    };
    const onNext = () => {
        const nextIndex = (swiper?.realIndex + 1) % 3;
        swiper?.slideToLoop(nextIndex);
        setActive(swiper?.realIndex);
    };

    const buyLinkLocale = buyLinkMap3[locale] || buyLinkMap3['us'];
    if (locale === 'za' && IS_ZA_SALE) {
        buyLinkLocale.river2_pro = {
            [BuyBtnType.Shopify]: 'https://za.ecoflow.com/products/river-2-pro-portable-power-station',
        };
    }

    const onLink = (link: string, type: string, btnName: string, pName: string, signup = false) => {
        if (signup) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
            return;
        }
        try {
            // fb埋点
            if (type === 'amazon') {
                window?.fbq('track', 'AddToWishlist');
            }
            if (type === 'rakuten') {
                window?.fbq('track', 'donate');
            }
            if (type === 'store') {
                window?.fbq('track', 'Search');
            }
            if (type === 'notify') {
                window?.fbq('track', 'Contact');
            }
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: `buy_on_${['store', 'amazon', 'notify'].includes(type) ? (type === 'notify' ? 'store' : type) : 'other'}`,
                product_name: btnName,
                button_name: pName,
                list_name: 'Middle Product List',
            });
        } catch (e) {
            console.log(e);
        } finally {
            window.location.href = link;
        }
    };

    return (
        <div className={`river2_details_D ${css.D_4}`}>
            <div className="bgImg">
                <EFPic name={['4.webp', '4.jpg']} className={'fullImgs'} alt={t('river2.details.sec4_title')} aria-label={t('river2.details.sec4_title')} />
                <div className="innerBox">
                    <p className="title">{t('river2.details.sec3_title')}</p>
                    <div className="swiperBox">
                        <Swiper
                            className={`river2_deatails_D_swiper`}
                            slidesPerView={'auto'}
                            spaceBetween={(winW / 375) * 15}
                            initialSlide={0}
                            preloadImages={false}
                            lazy
                            loop={true}
                            centeredSlides
                            grabCursor
                            onSwiper={(swiper: any) => setSwiper(swiper)}
                            onSlideChange={(swiper: any) => onSlideChange(swiper)}
                        >
                            <SwiperSlide>
                                <div className="product-wrapper product-river2-pro">
                                    {['za'].includes(locale) && !IS_ZA_END && (
                                        <div className="icon-act">
                                            <IconAct />
                                            <p>Double EcoCredits April 15–29 Only</p>
                                        </div>
                                    )}
                                    <div className="name">{t('river2.details.sec4_river2_pro')}</div>
                                    <div className="desc">{t('river2.details.sec4_river2_pro_desc')}</div>
                                    <div className="image-box">
                                        {locale === 'ph' ? (
                                            <img
                                                src="https://websiteoss.ecoflow.com/upload/image/1751250608353/1.jpg"
                                                className="containImg"
                                                alt={t('river2.details.sec4_river2')}
                                                aria-label={t('river2.details.sec4_river2')}
                                            />
                                        ) : (
                                            <EFPic
                                                name={[
                                                    `D_river2_pro_${locale === 'jp' ? 'en' : imgSpec}.webp`,
                                                    `D_river2_pro_${locale === 'jp' ? 'en' : imgSpec}.jpg`,
                                                ]}
                                                className="containImg"
                                                alt={t('river2.details.sec4_river2')}
                                                aria-label={t('river2.details.sec4_river2')}
                                            />
                                        )}
                                    </div>
                                    <div className="btn-wrapper">
                                        <div className="btns">
                                            {BuyBtnType.Notify in buyLinkLocale.river2_pro && (
                                                <div className="btn-amazon buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() =>
                                                            onLink(
                                                                buyLinkLocale.river2_pro[BuyBtnType.Notify],
                                                                'notify',
                                                                'Notify Me',
                                                                'RIVER 2 Pro',
                                                                buyLinkLocale.river2_pro?.signup,
                                                            )
                                                        }
                                                    >
                                                        <div className="text">{t('river2.details.sec4_btn_notify')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.Shopify in buyLinkLocale.river2_pro && (
                                                <div className="btn-shopify buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() =>
                                                            onLink(buyLinkLocale.river2_pro[BuyBtnType.Shopify], 'store', 'Buy on Ecoflow Store', 'RIVER 2 Pro')
                                                        }
                                                    >
                                                        {!['cis'].includes(locale) && (
                                                            <div className="icon icon-shopify">
                                                                <EFShopify />
                                                            </div>
                                                        )}
                                                        <div className="text">{t('river2.details.sec4_btn_shopify')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.Amazon in buyLinkLocale.river2_pro && (
                                                <div className="btn-amazon buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() =>
                                                            onLink(buyLinkLocale.river2_pro[BuyBtnType.Amazon], 'amazon', 'Buy on Amazon', 'RIVER 2 Pro')
                                                        }
                                                    >
                                                        <div className="icon">
                                                            <EFAmazon />
                                                        </div>
                                                        <div className="text">{t('river2.details.sec4_btn_amazon')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.Rakuten in buyLinkLocale.river2_pro && (
                                                <div className="btn-rakuten buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() =>
                                                            onLink(buyLinkLocale.river2_pro[BuyBtnType.Rakuten], 'rakuten', 'Buy on Rakuten', 'RIVER 2 Pro')
                                                        }
                                                    >
                                                        <div className="icon icon-rakuten">
                                                            <EFRakuten />
                                                        </div>
                                                        <div className="text">{t('river2.details.sec4_btn_rakuten')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.Lotte in buyLinkLocale.river2_pro && (
                                                <div className="btn-lotte buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() =>
                                                            onLink(buyLinkLocale.river2_pro[BuyBtnType.Lotte], 'lotte', 'Buy on Lotte', 'RIVER 2 Pro')
                                                        }
                                                    >
                                                        <div className="icon"></div>
                                                        <div className="text">{t('river2.details.sec4_btn_lotte')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.JD in buyLinkLocale.river2_pro && (
                                                <div className="btn-jd buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() => onLink(buyLinkLocale.river2_pro[BuyBtnType.JD], 'JD', 'Buy on JD', 'RIVER 2 Pro')}
                                                    >
                                                        <div className="icon">
                                                            <EFJD />
                                                        </div>
                                                        <div className="text">{t('river2.details.sec4_btn_jd')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.Soon in buyLinkLocale.river2_pro && (
                                                <div className="btn-soon buy-btn">
                                                    <div className="text">{t('river2.details.sec4_btn_soon')}</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <p className="price">R11,999</p>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="product-wrapper product-river2-max">
                                    <div className="name">{t('river2.details.sec4_river2_max')}</div>
                                    <div className="desc">{t('river2.details.sec4_river2_max_desc')}</div>
                                    <div className="image-box">
                                        {locale === 'ph' ? (
                                            <img
                                                src="https://websiteoss.ecoflow.com/upload/image/1751250608741/2.jpg"
                                                className="containImg"
                                                alt={t('river2.details.sec4_river2')}
                                                aria-label={t('river2.details.sec4_river2')}
                                            />
                                        ) : (
                                            <EFPic
                                                name={[
                                                    `D_river2_max_${locale === 'jp' ? 'en' : imgSpec}.webp`,
                                                    `D_river2_max_${locale === 'jp' ? 'en' : imgSpec}.jpg`,
                                                ]}
                                                className="containImg"
                                                alt={t('river2.details.sec4_river2')}
                                                aria-label={t('river2.details.sec4_river2')}
                                            />
                                        )}
                                    </div>
                                    <div className="btn-wrapper">
                                        <div className="btns">
                                            {BuyBtnType.Notify in buyLinkLocale.river2_max && (
                                                <div className="btn-amazon buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() =>
                                                            onLink(
                                                                buyLinkLocale.river2_max[BuyBtnType.Notify],
                                                                'notify',
                                                                'Notify Me',
                                                                'RIVER 2 Max',
                                                                buyLinkLocale.river2_max?.signup,
                                                            )
                                                        }
                                                    >
                                                        <div className="text">{t('river2.details.sec4_btn_notify')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.Shopify in buyLinkLocale.river2_max && (
                                                <div className="btn-shopify buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() =>
                                                            onLink(buyLinkLocale.river2_max[BuyBtnType.Shopify], 'store', 'Buy on Ecoflow Store', 'RIVER 2 Max')
                                                        }
                                                    >
                                                        {!['cis'].includes(locale) && (
                                                            <div className="icon">
                                                                <EFShopify />
                                                            </div>
                                                        )}
                                                        <div className="text">{t('river2.details.sec4_btn_shopify')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.Amazon in buyLinkLocale.river2_max && (
                                                <div className="btn-amazon buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() =>
                                                            onLink(buyLinkLocale.river2_max[BuyBtnType.Amazon], 'amazon', 'Buy on Amazon', 'RIVER 2 Max')
                                                        }
                                                    >
                                                        <div className="icon">
                                                            <EFAmazon />
                                                        </div>
                                                        <div className="text">{t('river2.details.sec4_btn_amazon')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.Rakuten in buyLinkLocale.river2_max && (
                                                <div className="btn-rakuten buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() =>
                                                            onLink(buyLinkLocale.river2_max[BuyBtnType.Rakuten], 'rakuten', 'Buy on Rakuten', 'RIVER 2 Max')
                                                        }
                                                    >
                                                        <div className="icon icon-rakuten">
                                                            <EFRakuten />
                                                        </div>
                                                        <div className="text">{t('river2.details.sec4_btn_rakuten')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.Lotte in buyLinkLocale.river2_max && (
                                                <div className="btn-lotte buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() =>
                                                            onLink(buyLinkLocale.river2_max[BuyBtnType.Lotte], 'lotte', 'Buy on Lotte', 'RIVER 2 Max')
                                                        }
                                                    >
                                                        <div className="icon"></div>
                                                        <div className="text">{t('river2.details.sec4_btn_lotte')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.JD in buyLinkLocale.river2_max && (
                                                <div className="btn-jd buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() => onLink(buyLinkLocale.river2_max[BuyBtnType.JD], 'JD', 'Buy on JD', 'RIVER 2 Max')}
                                                    >
                                                        <div className="icon">
                                                            <EFJD />
                                                        </div>
                                                        <div className="text">{t('river2.details.sec4_btn_jd')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.Soon in buyLinkLocale.river2_max && (
                                                <div className="btn-soon buy-btn">
                                                    <div className="text">{t('river2.details.sec4_btn_soon')}</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <p className="price">R7,999</p>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="product-wrapper product-river2">
                                    <div className="name">{t('river2.details.sec4_river2')}</div>
                                    <div className="desc">{t('river2.details.sec4_river2_desc')}</div>
                                    <div className="image-box">
                                        {locale === 'ph' ? (
                                            <img
                                                src="https://websiteoss.ecoflow.com/upload/image/1751250608546/3.jpg"
                                                className="containImg"
                                                alt={t('river2.details.sec4_river2')}
                                                aria-label={t('river2.details.sec4_river2')}
                                            />
                                        ) : (
                                            <EFPic
                                                name={[`D_river2_${locale === 'jp' ? 'en' : imgSpec}.webp`, `D_river2_${locale === 'jp' ? 'en' : imgSpec}.jpg`]}
                                                className="containImg"
                                                alt={t('river2.details.sec4_river2')}
                                                aria-label={t('river2.details.sec4_river2')}
                                            />
                                        )}
                                    </div>
                                    <div className="btn-wrapper">
                                        <div className="btns">
                                            {BuyBtnType.Notify in buyLinkLocale.river2 && (
                                                <div className="btn-amazon buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() =>
                                                            onLink(
                                                                buyLinkLocale.river2[BuyBtnType.Notify],
                                                                'notify',
                                                                'Notify Me',
                                                                'RIVER 2',
                                                                buyLinkLocale.river2?.signup,
                                                            )
                                                        }
                                                    >
                                                        <div className="text">{t('river2.details.sec4_btn_notify')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.Shopify in buyLinkLocale.river2 && (
                                                <div className="btn-shopify buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() =>
                                                            onLink(buyLinkLocale.river2[BuyBtnType.Shopify], 'store', 'Buy on Ecoflow Store', 'RIVER 2')
                                                        }
                                                    >
                                                        {!['ru', 'cis'].includes(locale) && (
                                                            <div className="icon">
                                                                <EFShopify />
                                                            </div>
                                                        )}
                                                        <div className="text">{t('river2.details.sec4_btn_shopify')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.Amazon in buyLinkLocale.river2 && (
                                                <div className="btn-amazon buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() => onLink(buyLinkLocale.river2[BuyBtnType.Amazon], 'amazon', 'Buy on Amazon', 'RIVER 2')}
                                                    >
                                                        <div className="icon">
                                                            <EFAmazon />
                                                        </div>
                                                        <div className="text">{t('river2.details.sec4_btn_amazon')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.Rakuten in buyLinkLocale.river2 && (
                                                <div className="btn-rakuten buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() => onLink(buyLinkLocale.river2[BuyBtnType.Rakuten], 'rakuten', 'Buy on Rakuten', 'RIVER 2')}
                                                    >
                                                        <div className="icon">
                                                            <EFRakuten />
                                                        </div>
                                                        <div className="text">{t('river2.details.sec4_btn_rakuten')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.Lotte in buyLinkLocale.river2 && (
                                                <div className="btn-lotte buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() => onLink(buyLinkLocale.river2[BuyBtnType.Lotte], 'lotte', 'Buy on Lotte', 'RIVER 2')}
                                                    >
                                                        <div className="icon"></div>
                                                        <div className="text">{t('river2.details.sec4_btn_lotte')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.JD in buyLinkLocale.river2 && (
                                                <div className="btn-jd buy-btn">
                                                    <div
                                                        className="link"
                                                        onClick={() => onLink(buyLinkLocale.river2[BuyBtnType.JD], 'JD', 'Buy on JD', 'RIVER 2')}
                                                    >
                                                        <div className="icon">
                                                            <EFJD />
                                                        </div>
                                                        <div className="text">{t('river2.details.sec4_btn_jd')}</div>
                                                    </div>
                                                </div>
                                            )}
                                            {BuyBtnType.Soon in buyLinkLocale.river2 && (
                                                <div className="btn-soon buy-btn">
                                                    <div className="text">{t('river2.details.sec4_btn_soon')}</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <p className="price">R3,999</p>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                        <ul className="paginations">
                            {[1, 2, 3].map((_item: any, k: number) => (
                                <li className={`pagination-item ${k === active ? 'active' : ''}`} key={k}></li>
                            ))}
                        </ul>
                        <div className="swiper-btns">
                            <span className="pageBtn prev" onClick={onPrev}>
                                <EFarrow fill="rgba(255, 255, 255, 0.3)" />
                            </span>
                            <span className="pageBtn next" onClick={onNext}>
                                <EFarrow fill="rgba(255, 255, 255, 0.3)" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
